import React from 'react';
import { shape, arrayOf, string } from 'prop-types';

import YouTube from '../components/YouTube';
import BackButton from '../components/BackButton';

const Video = ({ match, history, dataLayer, terms }) => (
  <div>
    <BackButton history={history} terms={terms} />
    <YouTube
      src={match.params.id}
      title={match.params.title}
      dataLayer={dataLayer}
    />
  </div>
);

Video.propTypes = {
  match: shape().isRequired,
  history: shape().isRequired,
  dataLayer: arrayOf().isRequired,
  terms: arrayOf(string).isRequired,
};

export default Video;



// WEBPACK FOOTER //
// ./src/Routes/Video.jsx